module.exports = __webpack_public_path__ + "67aa9b0196d73565c052b67613baf411.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/GS.svg
// module id = amR2
// module chunks = 0